import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { useBffClient } from 'src/app/hooks/data/useBffClient';
import type { Cart } from 'src/app/types';

type CartDeleteItemPayload = { cartId: string; itemId: string };

export const useCartDeleteItem = (options?: UseMutationOptions<Cart, AxiosError, CartDeleteItemPayload, unknown>) => {
  const authClient = useBffClient();

  return useMutation<Cart, AxiosError, CartDeleteItemPayload, unknown>(
    ({ cartId, itemId }) => authClient.delete(`/v2/carts/${cartId}/items/${itemId}`).then(res => res.data),
    options
  );
};
